export default __webpack_public_path__ + "static/03-38153cf4728df70c1ca9ca7a99614ed8.jpg";